import last from 'lodash/last'
import find from 'lodash/find'
import { TIMEZONES } from './tttime'

/**
 * Auto complete words like "yesterday", "today".
 *
 * For example, autoCompleteText("Tomo") will return "rrow"
 *
 * @param {string} text
 * @return {string} Returns a suffix a match is found
 */
export function autoComplete (text) {
  const words = text.split(' ')
  const last = words[words.length - 1]

  const match = find(DICTIONARY, word => {
    return word.toLowerCase().indexOf(last.toLowerCase()) === 0
  })

  if (match) {
    return match.substr(last.length)
  }

  // a special case, to easily auto complete a time like "09:00"
  if (text.charAt(text.length - 1) === ':') {
    return '00'
  }

  return ''
}

const relativeDays = [
  'today',
  'tomorrow',
  'yesterday',
  'next',
  'last',
  'now'
]

const weekdays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]

const timezones = TIMEZONES.map(timezone => {
  return last(timezone.split('/')).replace(/_/g, ' ')
})

// dictionary of words for auto completion
export const DICTIONARY = [].concat(relativeDays, weekdays, timezones)



// WEBPACK FOOTER //
// ./src/tttime/autoComplete.js